document.addEventListener("DOMContentLoaded", () => {
  function openDialog(dialog) {
    dialog.classList.add("opening");
    dialog.showModal();

    dialog.addEventListener("animationend", () => dialog.classList.remove("opening"), { once: true });
  }

  function animateClose(dialog) {
    dialog.classList.add("closing");

    dialog.addEventListener(
      "animationend",
      () => {
        dialog.classList.remove("closing");
        dialog.close();
      },
      { once: true }
    );
  }

  // Use pointerdown instead of click
  document.addEventListener("pointerdown", (e) => {
    const trigger = e.target.closest("[data-dl-target]");
    const openDialogEl = document.querySelector("dialog[open]");

    if (trigger) {
      const dialog = document.querySelector(trigger.dataset.dlTarget);
      const action = trigger.dataset.dlAction || "toggle";

      if (action === "open") openDialog(dialog);
      else if (action === "close") animateClose(dialog);
      else dialog.open ? animateClose(dialog) : openDialog(dialog);

      return;
    }

    // Outside clicks
    if (openDialogEl) {
      const rect = openDialogEl.getBoundingClientRect();
      const inside =
        e.clientX >= rect.left && e.clientX <= rect.right && e.clientY >= rect.top && e.clientY <= rect.bottom;

      if (!inside) animateClose(openDialogEl);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      const openDialogEl = document.querySelector("dialog[open]");
      if (openDialogEl) animateClose(openDialogEl);
    }
  });
});
